import { DateTime } from 'luxon';

const makeLuxonDate = (
  date: string | Date,
  filter?: Intl.DateTimeFormatOptions
) => {
  if (!!date) {
    return DateTime.fromISO(date.toString())
      .setLocale('pt-BR')
      .setZone('America/Sao_Paulo')
      .toLocaleString(!!filter ? filter : undefined);
  } else return '--:--:--';
};

export default makeLuxonDate;
